/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { combineReducers } from 'redux';
import subHours from 'date-fns/sub_hours';
import { createAPIReducer } from './api';
import { types } from '../actions/dashboard';

const defaultState = {
  from: subHours(new Date(), 1),
  to: new Date(),
  by: 'hour',
};

const getTimes = (state = defaultState, action) => {
  const { type, payload } = action;
  if (type === types.getTimes) {
    return payload;
  }
  return state;
};

const getDeveui = (state = [], action) => {
  const { type, payload } = action;
  if (type === types.getDeveui) {
    return payload;
  }
  return state;
};

const getDps = (state = [], action) => {
  const { type, payload } = action;
  if (type === types.getDps) {
    return payload.join(',');
  }
  return state;
};

const getRefreshCount = (state = 0, action) => {
  const { type, payload } = action;
  if (type === types.getRefreshCount) {
    return payload;
  }
  return state;
};

const getGpsColor = (state = {}, action) => {
  const { type, payload } = action;
  if (type === types.getGpsColor) {
    return payload;
  }
  return state;
};

const getDashboard = createAPIReducer(types.getDashboard);

export default combineReducers({
  getTimes,
  getDeveui,
  getDashboard,
  getDps,
  getRefreshCount,
  getGpsColor,
});




// WEBPACK FOOTER //
// ./src/redux/reducers/dashboard.js